module.exports = __webpack_public_path__ + "static/media/ranked_ballot_3.702f5955.png";